import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromContacts from '@reducers/index'
import { ContactsActions } from '@actions/index'
import { sortContact,getMostRecentStatusCampaigns } from '@utilities/function-utils';
import { ContactModel, FilterContactsModel, RequestModel, ResultBulkAddModel } from '@models/index';


@Injectable({
  providedIn: 'root'
})

export class ContactsFacadeService {

  constructor(private store: Store<any>) { }

  getContacts$(): Observable<ContactModel[]> {
    return this.store.select(fromContacts.getContacts).pipe(
      map(items => items.map(item => ({
        ...item,
        campaignNames: item.history.campaigns.map(data => data.name).join(","),
        status: getMostRecentStatusCampaigns(item.history.campaigns)
      }))),
      map(items => items.sort(sortContact))
    )
  }

  getContactAdded$(): Observable<boolean> {
    return this.store.select(fromContacts.getContactAdded)
  }

  getTotalContact$(): Observable<number> {
    return this.store.select(fromContacts.getTotalContact)
  }

  getContactError$(): Observable<string> {
    return this.store.select(fromContacts.getErrorContact)
  }

  searchContactsByLocation(pages: { page: number, size: number }) {
    this.store.dispatch(ContactsActions.searchContactsByLocation({ pages }))
  }

  searchContactsByQueryByLocation(payload: { page: number, size: number, query: string }) {
    this.store.dispatch(ContactsActions.searchContactsByQueryByLocation({ payload }))
  }

  searchContactsByBusiness(pages: { page: number, size: number }) {
    this.store.dispatch(ContactsActions.searchContactsByBusiness({ pages }))
  }

  searchContactsByQueryByBusiness(payload: { page: number, size: number, query: string }) {
    this.store.dispatch(ContactsActions.searchContactsByQueryByBusiness({ payload }))
  }

  createContact(payload: { contact: ContactModel, campaignId: string }) {
    this.store.dispatch(ContactsActions.createContacts(payload))
  }

  bulkAddContacts(payload: { contact: ContactModel, campaignId: string }[]) {
    this.store.dispatch(ContactsActions.bulkAddContacts({ payload }))
  }

  editContact(payload: { contact: ContactModel, campaignId: string }) {
    this.store.dispatch(ContactsActions.editContact(payload))
  }

  setContactAdded(contactAdded: boolean) {
    this.store.dispatch(ContactsActions.setContactAdded({ contactAdded }))
  }

  deleteContact(contactId: string) {
    this.store.dispatch(ContactsActions.deleteContact({ contactId }))
  }

  filterContactsByStatusBusiness(payload: { page: number, size: number, filter: FilterContactsModel }) {
    const request: RequestModel = {
      params: `contacts/business/filter?page=${payload.page}&size=${payload.size}`,
      payload: payload.filter
    }
    this.store.dispatch(ContactsActions.filterContactsByStatusBusiness({ request }))
  }

  isBulkAdded$(): Observable<boolean> {
    return this.store.select(fromContacts.isBulkAdded)
  }
  getResultBulkAdded$(): Observable<ResultBulkAddModel> {
    return this.store.select(fromContacts.getResultBulkAdded)
  }
  clearResultBulkAdded() {
    this.store.dispatch(ContactsActions.clearResultBulkAdd())
  }
  getExportDataContactCount$(): Observable<number> {
    return this.store.select(fromContacts.getExportDataContactCount)
  }

  exportDataContact(payload: { locationId: string, startDate: number, endDate: number }) {
    const request: RequestModel = {
      params: `contacts/exportContact?locationId=${payload.locationId}&startTime=${payload.startDate}&endTime=${payload.endDate}`,
      payload: payload.locationId
    }
    this.store.dispatch(ContactsActions.exportDataContact({ request }))
  }
  isContactExport$(): Observable<boolean> {
    return this.store.select(fromContacts.isContactExport)
  }
  setExportContactExport(data: boolean) {
    this.store.dispatch(ContactsActions.setExportDataContact({ isExporContact: data }))
  }

  exportDataContactCount(payload: {locationId: string, startDate: number, endDate: number}) {
    const request: RequestModel = {
      params: `contacts/exportContact-count?locationId=${payload.locationId}&startTime=${payload.startDate}&endTime=${payload.endDate}`,
      payload: payload.locationId
    }
    this.store.dispatch(ContactsActions.exportDataContactCount({ request }))
  }
}
